import { LocalStorage } from '@zeronejs/utils';
export interface LocalStorageEntities {
    // token
    giikin_chatgpt: string;
   
}
// docs: https://zerone.top/zh/techniques/utils.html#localstorage
export const vueLocalStorage = new LocalStorage<LocalStorageEntities>();
